import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonWithIconComponent} from '../buttons/button-with-icon/button-with-icon.component';

/**
 * Modale de confirmation générique — harmonisée avec ConfirmCancelActionModalComponent.
 * Fermée avec close(true) si l'utilisateur confirme, dismiss() s'il annule.
 * Le dismiss() (et non close(false)) est utilisé pour l'annulation afin que
 * unsavedChangesGuard puisse distinguer confirmation et abandon via catchError.
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [TranslateModule, ButtonWithIconComponent],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  protected readonly modal = inject(NgbActiveModal);

  @Input() title = '';
  @Input() message = '';
  @Input() confirmLabel = 'common.yes';
  @Input() cancelLabel = 'common.no';
  /** Classe(s) additionnelles pour le bouton de confirmation, ex. 'bg-french-pink' (suppression) ou 'bg-blue' (action principale). */
  @Input() confirmClass = 'bg-french-pink';
}
